import { jsxs as i, jsx as C } from "react/jsx-runtime";
function a(r) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.2047 18.8767C18.2047 14.9996 15.0623 11.8559 11.1853 11.8555C7.30794 11.8555 4.16412 14.9993 4.16412 18.8767C4.16446 22.7537 7.30815 25.8961 11.1853 25.8961V29.3727L10.6437 29.3591C5.27672 29.0867 0.973281 24.7836 0.701081 19.4165L0.6875 18.8767C0.6875 13.0793 5.38786 8.37891 11.1853 8.37891L11.7251 8.39249C17.2713 8.67377 21.6813 13.2605 21.6813 18.8767L21.6677 19.4165C21.3864 24.9625 16.8011 29.3724 11.1853 29.3727V25.8961C15.0621 25.8958 18.2044 22.7535 18.2047 18.8767Z",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M26.5202 0.700195C28.0666 0.700195 29.321 1.95328 29.321 3.49967V11.1598C29.3206 12.7059 28.0664 13.9593 26.5202 13.9593H22.7064C22.1923 12.9004 21.5799 11.9181 20.8861 11.027H26.3874V3.63249H18.2467V8.3903C17.3373 7.69342 16.3544 7.12177 15.3145 6.69499V3.49967C15.3145 1.95328 16.5675 0.700195 18.1139 0.700195H26.5202Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.2473 24.314C21.5653 24.3662 21.0547 24.9614 21.1069 25.6434C21.1591 26.3255 21.7543 26.8361 22.4364 26.7839C25.6817 26.5355 28.148 23.8282 28.1542 20.6279L28.5671 20.9821L28.6676 21.0593C29.1829 21.4178 29.8958 21.3351 30.3133 20.8484C30.7309 20.3617 30.704 19.6445 30.2713 19.1897L30.1797 19.1021L27.5208 16.8213C27.0016 16.376 26.2199 16.4358 25.7745 16.955L23.4937 19.6139C23.0483 20.133 23.1082 20.9148 23.6273 21.3601C24.1465 21.8055 24.9283 21.7457 25.3736 21.2265L25.6698 20.8799C25.5402 22.685 24.1061 24.1717 22.2473 24.314Z",
            fill: "rgb(var(--fill-primary))"
          }
        )
      ]
    }
  );
}
export {
  a as CircleToSquareSwapIcon
};
